import http from '@/utils/http'

export default {
  getQRCode () {
    return http.get('/promotion/api/v1/official/website/application')
  },
  getApplication (parmas) {
    return http.post('/promotion/api/v1/official/website/login/qrcode', parmas)
  },
  getRegister (parmas) {
    return http.post('/promotion/api/v1/official/website/register', parmas)
  }
}



// WEBPACK FOOTER //
// ./src/components/register/api/index.js